
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/drainage",
      function () {
        return require("private-next-pages/services/drainage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/drainage"])
      });
    }
  